import { render, staticRenderFns } from "./viewModule.vue?vue&type=template&id=56d7bcd0&scoped=true&"
import script from "./viewModule.vue?vue&type=script&lang=js&"
export * from "./viewModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7bcd0",
  null
  
)

export default component.exports